var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z",
    fill: "#E63335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9474 18.9474H21.0526V13.0526C21.0526 12.4737 20.5789 12 20 12C19.4211 12 18.9474 12.4737 18.9474 13.0526V18.9474H13.0526C12.4737 18.9474 12 19.4211 12 20C12 20.5789 12.4737 21.0526 13.0526 21.0526H18.9474V26.9474C18.9474 27.5263 19.4211 28 20 28C20.5789 28 21.0526 27.5263 21.0526 26.9474V21.0526H26.9474C27.5263 21.0526 28 20.5789 28 20C28 19.4211 27.5263 18.9474 26.9474 18.9474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.0ef0156391764eb93a49137b1fce1be9.svg";
export { ForwardRef as ReactComponent };